import React from "react";
import { KeyboardBackspace } from "@mui/icons-material";
import { useHistory } from "react-router";
import { paginationStateToUrlSearch } from "../../../../common/hooks/useStatefulPagination";

type PageHeaderBackProps = {
  children: React.ReactNode;
} & ({ to: string; onClick?: never } | { to?: never; onClick: () => void });

export const PageHeaderBack: React.FC<PageHeaderBackProps> = ({ to, onClick, children }) => {
  const history = useHistory();
  if (onClick) {
    return (
      <button
        type="button"
        className="text-decoration-none neutral-700 text-weight-regular inline-flex align-items-center border-0 bg-transparent p-0"
        onClick={onClick}
      >
        <KeyboardBackspace className="font-size-unset mr-xs" />
        {children}
      </button>
    );
  }

  const locationState: { pagination?: any } = history?.location?.state || {};
  let href = to;
  if (locationState.pagination) {
    href = `${href}?${paginationStateToUrlSearch(locationState.pagination)}`;
  }

  return (
    <a className="text-decoration-none neutral-700 text-weight-regular" href={href}>
      <KeyboardBackspace className="font-size-unset mr-xs" />
      {children}
    </a>
  );
};
